'use client';

import { FC } from 'react';
import { NavigationBackButton } from '../NavigationBackButton/NavigationBackButton.use-client';
import { NavigationBackButtonComponentProps } from '../../common/types';
import { useRouter } from 'next/navigation';

// This client-side wrapper is necessary for passing the base Button component,
// Otherwise, it will return an error (if Button is passed from the page which is server side)

type BaseProps = Omit<
  NavigationBackButtonComponentProps,
  'ButtonBase' | 'handleVirtualNavigation'
>;

type WithDelayedRouteRefresh = BaseProps & {
  withDelayedRouteRefresh?: boolean;
  handleVirtualNavigation?: never;
};

type WithHandleVirtualNavigation = BaseProps & {
  withDelayedRouteRefresh?: never;
  handleVirtualNavigation: NavigationBackButtonComponentProps['handleVirtualNavigation'];
};

type NavigationBackButtonClientWrapperProps =
  | WithDelayedRouteRefresh
  | WithHandleVirtualNavigation;

const NavigationBackButtonClientWrapper: FC<
  NavigationBackButtonClientWrapperProps
> = ({
  handleVirtualNavigation,
  isDisabled,
  noPadding,
  withDelayedRouteRefresh,
}) => {
  const router = useRouter();

  return (
    <NavigationBackButton
      noPadding={noPadding}
      isDisabled={isDisabled}
      handleVirtualNavigation={
        withDelayedRouteRefresh // TODO: logic related to this prop can be removed after all documentation will come in pdf format and iframe won't be needed anymore
          ? () => {
              router.back();

              setTimeout(() => {
                router.refresh();
              }, 500);
              // ? above setTimeout-based hack tricks the browser into a delayed router.refresh() after calling router.back() to ensure target page server actions refetch
              // ? helps on Accept Offer pages to make sure that the latest offer is fetched and BE error is avoided on pressing confirm, after going back from Legal Documents page
            }
          : handleVirtualNavigation
      }
    />
  );
};

export { NavigationBackButtonClientWrapper };
